import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GameTable } from '../../../../../shared/model/game-table';

@Component({
  selector: 'app-event-game-table-card',
  standalone: true,
  imports: [NgClass],
  templateUrl: './event-game-table-card.component.html',
  styleUrl: './event-game-table-card.component.css',
})
export class EventGameTableCardComponent {
  @Input() gameTable?: GameTable;

  private router: Router = inject(Router);

  protected getAcceptedPlayerCount(): number {
    if (!this.gameTable?.participations) {
      return 0;
    }
    return this.gameTable.participations.filter((p) => p.accepted).length;
  }

  protected isTableFull(): boolean {
    return this.gameTable?.isFull ?? false;
  }

  protected getPegiBadgeClass(minAge?: number): string {
    const age = minAge ?? 12;
    if (age >= 18) return 'bg-danger';
    if (age >= 16) return 'bg-warning text-dark';
    return 'bg-success';
  }

  protected onCardClick(event: Event): void {
    if (!this.gameTable?.id || this.isInteractiveTarget(event)) {
      return;
    }
    void this.router.navigate(['/tables/detail', this.gameTable.id]);
  }

  protected onCardKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    if (this.isInteractiveTarget(event)) {
      return;
    }
    event.preventDefault();
    this.onCardClick(event);
  }

  private isInteractiveTarget(event: Event): boolean {
    const target = event.target as HTMLElement | null;
    return !!target?.closest('a, button, input, select, textarea, label, [role="button"]');
  }
}
